import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {setupAuthInterceptors} from './services/authInterceptor';

setupAuthInterceptors();

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(app, rootElement);
} else {
  ReactDOM.render(app, rootElement);
}
